import type { FC, SVGProps } from 'react'

export const LinkArrow: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 42 42"
    clipRule="evenodd"
    fillRule="evenodd"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <g>
      <path
        d="M3.472,38.194l34.722,-34.722"
        strokeWidth="4.17px"
        stroke="currentColor"
        fill="none"
        fillRule="nonzero"
      />
      <path
        d="M3.472,3.472l34.722,0l0,34.722"
        strokeWidth="4.17px"
        stroke="currentColor"
        fill="none"
        fillRule="nonzero"
      />
    </g>
  </svg>
)
